<template>
	<v-form ref="form" lazy-validation @submit="submit" >
			<small>{{responseText}}</small>
			<v-card>
	            <v-text-field
	              :placeholder="translater.__('Route name', 'routes')"
	              v-model="displayName"
	             
	            ></v-text-field>
	        </v-card>
			<v-card>
				<label>{{translater.__('Lat')}}</label>
				<v-text-field
					v-model="lat"
				></v-text-field>
			</v-card>

			<v-card>
				<label>{{translater.__('Lng')}}</label>
				<v-text-field
					v-model="lng"
				></v-text-field>
			</v-card>



	        <!--v-card>
	            <v-switch
			      label="Create finish automatically"
			      v-model="createFinishCheckpointAutomatically"
			    ></v-switch>
			</v-card-->
			<v-card v-if="isLuonto">
				<!--v-select
	    		  v-model="selectedRouteGroup"	
			      :items="routeGroups"
			      :label="translater
		      		.__('RouteGroup', 'routes')"
			      item-text="text"
			      item-value="value"
			    ></v-select-->


			    <v-card-actions>
			    	<v-btn :disabled="!valid" color="success" small flat type="submit">
			    		<v-icon>save</v-icon>
			    		{{translater.__('Save')}}
			    	</v-btn>
			    </v-card-actions>

			</v-card>
		    
            
    </v-form>
</template>

<style scoped>
	.v-card{
		margin-bottom: 2em;
	}
</style>

<script>
	export default {
		name: 'NewRoute',
		data(){
			return {
				responseText: undefined,
				
				
			}
		},

		methods: {
			submit(e)
			{
				e.preventDefault();
				
				this.$store.dispatch('routes/store')
				.then((res) => {
					const {focusPoint} = res.data
					this.$store.dispatch('routes/setCenter', {
						lat: focusPoint.coordinates[1],
						lng: focusPoint.coordinates[0]
					})
					this.responseText = this.translater.__('Route created', 'routes');
					this.displayName = '';
					this.$store.commit('routes/store', res.data);
					// TODO: test if this is obsolete. It's been triggered in Index.vue
					//this.$store.commit('routes/setMarkers')
					//this.$store.dispatch('routes/setMarkerLeafletId', {id: res.data._id, leafletid: this.$store.getters['routes/newRoute'].marker._leafletid});

					this.$store.dispatch('locations/storeStart', res.data)
					.then((storeStartRes) => {
						
						this.$store.dispatch('routes/addLocation', 
						{
							routeId: res.data._id, 
							location: storeStartRes.data,
							isStart: true,
							
							emitRouteAdded: !this.$store.getters['routes/newRoute'].createFinishCheckpointAutomatically
						}, {root:true})

						if(this.$store.getters['routes/newRoute'].createFinishCheckpointAutomatically)
						{
							this.$store.dispatch('locations/storeFinish', res.data)
							.then((storeFinishRes) => {

								this.$store.dispatch('routes/addLocation', 
								{
									routeId: res.data._id, 
									location: storeFinishRes.data,
									isFinish: true,
									
									emitRouteAdded: true
								}, {root:true})
							})
						}


					})
					/*if(this.$store.getters['routes/newRoute'].createFinishCheckpointAutomatically)
					{
						this.$store.dispatch('locations/storeFinish', res.data);
						
					}*/



				})
				.catch((err) => {
					this.responseText = this.translater.__('Route name must be unique', 'routeValidator');
				})
			}
		},

		computed: {


			editMode()
			{
				return this.$store.getters['routes/editMode'];
			},

			valid()
			{
				return this.displayName.trim() !== '' &&
				this.lat !== '' &&
				this.lng !== '' &&
				!this.editMode
			},


			lat: {
				get()
				{
					return this.$store.getters['routes/newRoute'].marker._latlng.lat;
				},

				set(v)
				{
					this.$store.commit('routes/newRouteSetLat', v)
				}
			},

			lng: {
				get()
				{
					return this.$store.getters['routes/newRoute'].marker._latlng.lng
				},

				set(value)
				{
					this.$store.commit('routes/newRouteSetLng', value)
				}
			},



			isLuonto:{
				get()
				{


					return this.$store.getters['settings/isLuonto'];;
				}
			},

			selectedRouteGroup: {
				get()
				{
					return this.$store.getters['routes/newRoute'].routegroup
				},

				set(value)
				{
					this.$store.dispatch('routes/setSelectedNewRouteRouteGroup', value)
				}
			},

			routeGroups: {
				get()
				{
					return this.$store.getters['routes/routeGroups']
				}
			},

			translater: {
				get()
				{
					return this.$store.getters['translate/translater'];
				}
			},

			createFinishCheckpointAutomatically: {
				get: function()
				{
					return this.$store.getters['routes/newRoute'].createFinishCheckpointAutomatically
				},

				set: function(value)
				{
					this.$store.dispatch('routes/setCreateFinishCheckpointAutomatically', value)
				}
			},

			displayName: {
				get()
				{
					return this.$store.getters['routes/newRoute'].displayName;
				},

				set(value)
				{
					this.$store.dispatch('routes/setNewRouteDisplayName', value)
				}
			}
		}

	}
</script>